export const UPDATE_QUESTION_SETTINGS =
  'app/EditSessionPage/Settings/UPDATE_QUESTION_SETTINGS';

export const UPDATE_NARRATOR_SETTINGS =
  'app/EditSessionPage/Settings/UPDATE_NARRATOR_SETTINGS';

export const ADD_BLOCK = 'app/EditSessionPage/Settings/ADD_BLOCK';

export const REMOVE_BLOCK = 'app/EditSessionPage/Settings/REMOVE_BLOCK';

export const UPDATE_NARRATOR_ANIMATION =
  'app/EditSessionPage/Settings/UPDATE_NARRATOR_ANIMATION';

export const UPDATE_BLOCK_SETTINGS =
  'app/EditSessionPage/Settings/UPDATE_BLOCK_SETTINGS';

export const UPDATE_REFLECTION =
  'app/EditSessionPage/Settings/UPDATE_REFLECTION';

export const UPDATE_REFLECTION_FORMULA =
  'app/EditSessionPage/Settings/UPDATE_REFLECTION_FORMULA';

export const SWITCH_SPEECH_REFLECTION =
  'app/EditSessionPage/Settings/SWITCH_SPEECH_REFLECTION';

export const UPDATE_FORMULA = 'app/EditSessionPage/Settings/UPDATE_FORMULA';

export const ADD_FORMULA_CASE = 'app/EditSessionPage/Settings/ADD_FORMULA_CASE';

export const REMOVE_FORMULA_CASE =
  'app/EditSessionPage/Settings/REMOVE_FORMULA_CASE';

export const UPDATE_FORMULA_CASE =
  'app/EditSessionPage/Settings/UPDATE_FORMULA_CASE';

export const UPDATE_NARRATOR_MOVEMENT =
  'app/EditSessionPage/Settings/UPDATE_NARRATOR_MOVEMENT';

export const REORDER_NARRATOR_BLOCKS =
  'app/EditSessionPage/Settings/REORDER_NARRATOR_BLOCKS';

export const UPDATE_PAUSE_DURATION =
  'app/EditSessionPage/Settings/UPDATE_PAUSE_DURATION';

export const ADD_FORMULA_TARGET =
  'app/EditSessionPage/Settings/ADD_FORMULA_TARGET';

export const UPDATE_FORMULA_TARGET =
  'app/EditSessionPage/Settings/UPDATE_FORMULA_TARGET';

export const REMOVE_FORMULA_TARGET =
  'app/EditSessionPage/Settings/REMOVE_FORMULA_TARGET';

export const ADD_NEW_FORMULA = 'app/EditSessionPage/Settings/ADD_NEW_FORMULA';

export const REMOVE_FORMULA = 'app/EditSessionPage/Settings/REMOVE_FORMULA';
export const DUPLICATE_FORMULA =
  'app/EditSessionPage/Settings/DUPLICATE_FORMULA';

export const UPDATE_ENTIRE_NARRATOR =
  'app/EditSessionPage/Settings/UPDATE_ENTIRE_NARRATOR';
